import type { AccessLevel, TenantList } from "./types";

const possibleTenant: TenantList[] = [
  {
    tenant: "live",
    label: "Live",
  },
  {
    tenant: "preview-p",
    label: "Preview P",
  },
  {
    tenant: "preview-f",
    label: "Preview F",
  },
];

export function getPossibleTenants(
  access: Exclude<AccessLevel, null>
): TenantList[] {
  if (access === "extended") {
    return possibleTenant;
  }

  return possibleTenant.filter((tenant) => tenant.tenant !== "preview-p");
}

export function getPreviewDataAccessLevel(urlPath: string) {
  const location = new URL(urlPath);
  return location.searchParams.get("access") as AccessLevel;
}
